import { render, staticRenderFns } from "./ColumnViewer.vue?vue&type=template&id=177d412b&"
import script from "./ColumnViewer.vue?vue&type=script&lang=js&"
export * from "./ColumnViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports